import http from "@/settings/apiSettings";

// Instanța `client` (Auth) nu setează Authorization implicit (e folosită și pentru
// login, înainte să existe token). Endpoint-urile de mentenanță sunt [Authorize] +
// SuperAdmin, deci trimitem token-ul explicit pe fiecare cerere.
function authHeader() {
  return { headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") } };
}

class MaintenanceService {
  broadcast(minutes: number, message?: string): Promise<any> {
    return http.client.post("/Maintenance/broadcast", { Minutes: minutes, Message: message }, authHeader());
  }
  clear(): Promise<any> {
    return http.client.post("/Maintenance/clear", {}, authHeader());
  }
}
export default new MaintenanceService();
